"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6924,5457,9078,9213],{

/***/ 15457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCheckmarkCircle = function SvgCheckmarkCircle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M7 .333A6.667 6.667 0 1 0 13.668 7 6.674 6.674 0 0 0 7.001.333ZM7 13a6 6 0 1 1 6-6 6.006 6.006 0 0 1-6 6Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M9.765 5.097 6.237 8.626a.333.333 0 0 1-.472 0L4.237 7.097a.334.334 0 0 0-.472.472l1.528 1.528a1 1 0 0 0 1.415 0l3.529-3.528a.334.334 0 1 0-.472-.472Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgCheckmarkCircle);

/***/ }),

/***/ 19078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDerecha = function SvgDerecha(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 134 134"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ellipse", {
    cx: 66.581,
    cy: 66.653,
    rx: 64.01,
    ry: 64.438,
    style: {
      fill: "#fff",
      stroke: "CurrentColor",
      strokeWidth: 1
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M58.333 50 75 66.667 58.333 83.333",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "CurrentColor",
      strokeWidth: "6.67px",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M66.667 129.167c34.518 0 62.5-27.982 62.5-62.5s-27.982-62.5-62.5-62.5-62.5 27.982-62.5 62.5 27.982 62.5 62.5 62.5Zm0 4.166c36.819 0 66.666-29.847 66.666-66.666C133.333 29.848 103.486 0 66.667 0 29.848 0 0 29.848 0 66.667s29.848 66.666 66.667 66.666Z",
    style: {
      fill: "CurrentColor"
    }
  }));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgDerecha);

/***/ }),

/***/ 59213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIzquierda = function SvgIzquierda(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 134 134"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ellipse", {
    cx: 66.581,
    cy: 66.653,
    rx: 64.01,
    ry: 64.438,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M75 50 58.333 66.667 75 83.333",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "CurrentColor",
      strokeWidth: "6.67px"
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M66.667 129.167c34.518 0 62.5-27.982 62.5-62.5s-27.982-62.5-62.5-62.5-62.5 27.982-62.5 62.5 27.982 62.5 62.5 62.5Zm0 4.166c36.819 0 66.666-29.847 66.666-66.666C133.333 29.848 103.486 0 66.667 0 29.848 0 0 29.848 0 66.667s29.848 66.666 66.667 66.666Z",
    style: {
      fill: "CurrentColor"
    }
  }));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgIzquierda);

/***/ }),

/***/ 74371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ search_box_locations; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(77215);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/listbox/listbox.js + 3 modules
var listbox = __webpack_require__(19363);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(35703);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(62123);
// EXTERNAL MODULE: ./public/assets/icons/ArrowDownPri.svg
var ArrowDownPri = __webpack_require__(36094);
// EXTERNAL MODULE: ./public/assets/icons/CheckmarkCircle.svg
var CheckmarkCircle = __webpack_require__(15457);
;// CONCATENATED MODULE: ./components/atoms/combobox/Combobox.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                text-body--primary relative flex w-full items-center justify-between gap-2 rounded-full bg-white px-8 py-3 text-left text-text-primary\n                ",
        "\n              "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                      h-4 w-4 transition-transform\n                      ",
        "\n                    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                        relative flex cursor-default select-none items-center justify-between gap-6 truncate py-2 pl-3 pr-9\n                        ",
        "\n                        ",
        "\n                      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






/**
 * Combobox
 */ var Combobox = function(param) {
    var values = param.values, placeholder = param.placeholder, onChange = param.onChange, _className = param.className, className = _className === void 0 ? "" : _className, defaultValue = param.defaultValue, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    var ref = (0,react.useState)(placeholder && !defaultValue ? {
        id: "placeholder",
        label: placeholder
    } : defaultValue !== null && defaultValue !== void 0 ? defaultValue : values[0]), selected = ref[0], setSelected = ref[1];
    var onChangeHandler = function(value) {
        setSelected(value);
        onChange && onChange(value);
    };
    //Este codigo esta para cuando buscamos una localizacion desde el hero,
    //pero luego desde el donde estamos solo cambios de provincia,
    //da un error porque como se ha eligido anteriormente una poblacion
    //deja la locazacion anterior como por defecto, entonces
    //compruebo si en la provincia exite, si es asi funciona normal,
    //sino dejo el valor por defecto del placeholder.
    // TODO: Revisar como se crea el default value con rodri.
    (0,react.useEffect)(function() {
        setSelected(placeholder && !defaultValue ? {
            id: "placeholder",
            label: placeholder
        } : defaultValue !== null && defaultValue !== void 0 ? defaultValue : values[0]);
    }, [
        values,
        placeholder,
        defaultValue
    ]);
    (0,react.useEffect)(function() {
        setSelected(placeholder && !defaultValue ? {
            id: "placeholder",
            label: placeholder
        } : defaultValue !== null && defaultValue !== void 0 ? defaultValue : values[0]);
    }, []);
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox */.R, {
        value: selected,
        onChange: onChangeHandler,
        by: "id",
        disabled: disabled,
        children: function(param) {
            var open = param.open, value = param.value;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative mt-2 ".concat(className),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Button */.R.Button, {
                            className: function(param) {
                                var disabled = param.disabled;
                                return (0,es/* oneLine */.f9)(_templateObject(), disabled ? "cursor-not-allowed opacity-70" : "cursor-pointer");
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "block truncate",
                                        children: (ref1 = value === null || value === void 0 ? void 0 : value.label) !== null && ref1 !== void 0 ? ref1 : placeholder
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pointer-events-none flex items-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownPri["default"], {
                                            className: (0,es/* oneLine */.f9)(_templateObject1(), open ? "rotate-180" : ""),
                                            "aria-hidden": "true"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                            show: open,
                            as: "div",
                            leave: "transition ease-in duration-100",
                            leaveFrom: "opacity-100",
                            leaveTo: "opacity-0",
                            unmount: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Options */.R.Options, {
                                className: "absolute z-10 mt-2 max-h-60 w-full overflow-auto rounded-md bg-white py-1",
                                children: values.map(function(value) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Option */.R.Option, {
                                        value: value,
                                        className: function(param) {
                                            var active = param.active, selected = param.selected;
                                            return (0,es/* oneLine */.f9)(_templateObject2(), active ? "bg-surface-10 text-white" : "text-text-primary", selected ? "font-bold" : "cursor-pointer font-normal");
                                        },
                                        children: function(param) {
                                            var selected = param.selected;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    value.label,
                                                    selected && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckmarkCircle["default"], {
                                                        className: "h-4 w-4",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            });
                                        }
                                    }, value.id);
                                })
                            })
                        })
                    ]
                })
            });
        }
    });
};
Combobox.displayName = "Combobox";

;// CONCATENATED MODULE: ./components/atoms/combobox/index.ts

/* harmony default export */ var combobox = (Combobox);

;// CONCATENATED MODULE: ./components/molecules/search-box-locations/SearchBoxLocations.tsx



var ref;
/**
 * SearchBoxLocations
 */ var SearchBoxLocations = function(param) {
    var provinces = param.provinces, cities = param.cities, onCitiesChange = param.onCitiesChange, onProvincesChange = param.onProvincesChange;
    var ref1, ref2, ref3, ref4, ref5;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(combobox, (0,_object_spread/* default */.Z)({
                values: provinces.values,
                onChange: function(value) {
                    return onProvincesChange(provinces.values.find(function(province) {
                        return province.id === value.id;
                    }));
                }
            }, provinces.placeholder ? {
                placeholder: provinces.placeholder
            } : {
                defaultValue: provinces.defaultValue
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(combobox, (0,_object_spread/* default */.Z)({
                //eslint-disable-next-line
                //@ts-ignore
                values: (ref = cities === null || cities === void 0 ? void 0 : (ref1 = cities.cities) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[1]) === null || ref2 === void 0 ? void 0 : ref2.cities) !== null && ref !== void 0 ? ref : [],
                onChange: function(value) {
                    return onCitiesChange(value);
                },
                disabled: (cities === null || cities === void 0 ? void 0 : (ref3 = cities.cities) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[1]) === null || ref4 === void 0 ? void 0 : ref4.cities) ? ((ref5 = cities === null || cities === void 0 ? void 0 : cities.cities[1]) === null || ref5 === void 0 ? void 0 : ref5.cities.length) === 0 : true
            }, cities.defaultValue ? {
                defaultValue: cities.defaultValue
            } : {
                placeholder: cities.placeholder
            }))
        ]
    });
};
SearchBoxLocations.displayName = "SearchBoxLocations";

;// CONCATENATED MODULE: ./components/molecules/search-box-locations/index.ts

/* harmony default export */ var search_box_locations = (SearchBoxLocations);


/***/ }),

/***/ 76589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ housing_card; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(77215);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(60123);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(46572);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(62123);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
// EXTERNAL MODULE: ./components/atoms/icon/index.ts + 2 modules
var icon = __webpack_require__(64903);
// EXTERNAL MODULE: ./components/atoms/button/index.ts + 1 modules
var atoms_button = __webpack_require__(60825);
// EXTERNAL MODULE: ./components/molecules/card/index.ts + 1 modules
var card = __webpack_require__(25649);
;// CONCATENATED MODULE: ./components/organisms/housing-card/HousingCard.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                flex pb-2\n                ",
        "\n              "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var VARIANT_MAPS = {
    primary: " text-primary-400",
    secondary: "text-primary-400",
    alternative: "text-white"
};
var PopUpBookingLavanda = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5518), __webpack_require__.e(2667), __webpack_require__.e(9501), __webpack_require__.e(735)]).then(__webpack_require__.bind(__webpack_require__, 80735));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80735)
            ];
        }
    },
    ssr: false
});
/**
 * CardDondeEstamos
 */ var HousingCard = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, galeryProps = param.galeryProps, caption = param.caption, title = param.title, subtitle = param.subtitle, description = param.description, characteristics = param.characteristics, buttonText = param.buttonText, linkBoton = param.linkBoton, _textLink = param.textLink, textLink = _textLink === void 0 ? "" : _textLink, accommodationSelect = param.accommodationSelect, buildingSelect = param.buildingSelect, _active = param.active, active = _active === void 0 ? false : _active, _textColor = param.textColor, textColor = _textColor === void 0 ? "primary" : _textColor, _orientation = param.orientation, orientation = _orientation === void 0 ? "column" : _orientation, _characteristicsOrientation = param.characteristicsOrientation, characteristicsOrientation = _characteristicsOrientation === void 0 ? "column" : _characteristicsOrientation, contactData = param.contactData, email = param.email, phoneNumber = param.phoneNumber, defaultBuilding = param.defaultBuilding, defaultApartments = param.defaultApartments, province = param.province, _landing = param.landing, landing = _landing === void 0 ? false : _landing;
    var ref = (0,useTranslation/* default */.Z)("common"), t = ref.t, lang = ref.lang;
    var ref1 = (0,react.useState)(false), formOpen = ref1[0], setFormOpen = ref1[1];
    var popUpToggle = function() {
        setFormOpen(!formOpen);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUpBookingLavanda, {
                apartmentsByBuilding: accommodationSelect,
                buildings: buildingSelect,
                show: formOpen,
                province: province,
                onClose: popUpToggle,
                defaultBuilding: defaultBuilding,
                defaultApartment: defaultApartments
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                orientation: orientation,
                multimediaProps: galeryProps,
                className: "rounded-md bg-white ".concat(className),
                classNames: {
                    content: "flex flex-col"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex h-full flex-col justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat(VARIANT_MAPS[textColor], " mb-4 flex flex-col"),
                            children: [
                                caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-caption text-caption--small mb-1",
                                    children: caption
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-heading text-heading--h4 mb-1",
                                    children: title
                                }),
                                subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-body text-body--secondary mb-4 font-bold",
                                    children: subtitle
                                }),
                                description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-body text-body--primary font-light",
                                    children: description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                contactData ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col gap-2",
                                    children: [
                                        phoneNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms_link/* default */.Z, {
                                            underline: true,
                                            variant: textColor,
                                            className: "flex flex-row gap-1",
                                            href: "tel:".concat(phoneNumber),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                    src: "Call"
                                                }),
                                                " ",
                                                phoneNumber
                                            ]
                                        }),
                                        email && /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms_link/* default */.Z, {
                                            underline: true,
                                            variant: textColor,
                                            className: "flex flex-row gap-2",
                                            href: "mailto:".concat(email),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                    src: "Autor"
                                                }),
                                                " ",
                                                email
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,es/* oneLine */.f9)(_templateObject(), characteristicsOrientation === "row" ? "flex-row justify-between " : "flex-col gap-2"),
                                    children: characteristics === null || characteristics === void 0 ? void 0 : characteristics.map(function(element, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-row items-center gap-2 ".concat(VARIANT_MAPS[textColor]),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                    height: 20,
                                                    src: element.icon
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: element.text
                                                })
                                            ]
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-px w-full bg-primary-500 opacity-5"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " flex flex-row justify-between pt-3",
                                    children: active ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            buttonText && linkBoton ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                        href: landing ? "#Contacto" : linkBoton !== null && linkBoton !== void 0 ? linkBoton : "#",
                                                        prefetch: false,
                                                        passHref: true
                                                    }, !landing && {
                                                        locale: linkBoton.split("/")[1]
                                                    }), {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                                            className: "max-sm:hidden w-auto !px-5 !py-2",
                                                            variant: "outline",
                                                            size: "large",
                                                            as: "a",
                                                            children: buttonText
                                                        })
                                                    })),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: linkBoton !== null && linkBoton !== void 0 ? linkBoton : "#",
                                                        prefetch: false,
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                                            className: "w-auto sm:hidden",
                                                            variant: "outline",
                                                            size: "small",
                                                            as: "a",
                                                            children: buttonText
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                                        className: "max-sm:hidden w-auto !px-5 !py-2",
                                                        variant: "outline",
                                                        size: "large",
                                                        disabled: true,
                                                        children: buttonText
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                                        className: "w-auto sm:hidden",
                                                        variant: "outline",
                                                        size: "small",
                                                        disabled: true,
                                                        children: buttonText
                                                    })
                                                ]
                                            }),
                                            textLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                                                className: "".concat(landing ? "hidden" : "", " text-links--small"),
                                                underline: false,
                                                arrow: false,
                                                variant: "primary",
                                                as: "button",
                                                onClick: popUpToggle,
                                                children: textLink
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                                disabled: true,
                                                variant: "outline",
                                                size: "large",
                                                as: "button",
                                                children: t("components.organisms.housingCard.comingSoon")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: landing ? "#contacto" : "/".concat(lang, "/contacto"),
                                                passHref: true,
                                                locale: lang,
                                                prefetch: false,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                                                    arrow: false,
                                                    variant: "primary",
                                                    children: t("components.organisms.housingCard.letMeKnow")
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
HousingCard.displayName = "CardDondeEstamos";

;// CONCATENATED MODULE: ./components/organisms/housing-card/index.ts

/* harmony default export */ var housing_card = (HousingCard);


/***/ }),

/***/ 53835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ flexible_content; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(60123);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/templates/flexible-content/FlexibleContent.tsx






var Benefits = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(7028)]).then(__webpack_require__.bind(__webpack_require__, 97028));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97028)
            ];
        }
    }
});
var BuildingCarrousel = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(5044), __webpack_require__.e(3405)]).then(__webpack_require__.bind(__webpack_require__, 24324));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24324)
            ];
        }
    }
});
var Faqs = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 701).then(__webpack_require__.bind(__webpack_require__, 70701));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(70701)
            ];
        }
    }
});
var PopUpCorner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8234).then(__webpack_require__.bind(__webpack_require__, 88234));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88234)
            ];
        }
    }
});
var PopUpOpenPage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5518), __webpack_require__.e(9535)]).then(__webpack_require__.bind(__webpack_require__, 29535));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29535)
            ];
        }
    }
});
var WhatsappPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7591).then(__webpack_require__.bind(__webpack_require__, 87591));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87591)
            ];
        }
    }
});
var Hero = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8977).then(__webpack_require__.bind(__webpack_require__, 8977));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8977)
            ];
        }
    }
});
var GeneralCards = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(7171)]).then(__webpack_require__.bind(__webpack_require__, 67171));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67171)
            ];
        }
    }
});
var LaVidaEnBeCasa = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(3159)]).then(__webpack_require__.bind(__webpack_require__, 3159));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3159)
            ];
        }
    }
});
var AboutUs = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(3891)]).then(__webpack_require__.bind(__webpack_require__, 63891));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63891)
            ];
        }
    }
});
var AnchorMenu = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7173).then(__webpack_require__.bind(__webpack_require__, 87173));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87173)
            ];
        }
    }
});
var Apartments = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(5044), __webpack_require__.e(1699)]).then(__webpack_require__.bind(__webpack_require__, 52900));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52900)
            ];
        }
    }
});
var Blog = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3890).then(__webpack_require__.bind(__webpack_require__, 13890));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(13890)
            ];
        }
    }
});
var CardsBlog = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4547).then(__webpack_require__.bind(__webpack_require__, 64547));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64547)
            ];
        }
    }
});
var ContactForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(5518), __webpack_require__.e(2667), __webpack_require__.e(8400), __webpack_require__.e(949)]).then(__webpack_require__.bind(__webpack_require__, 53989));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53989)
            ];
        }
    }
});
var CrossTemplate = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5518), __webpack_require__.e(2667), __webpack_require__.e(2548)]).then(__webpack_require__.bind(__webpack_require__, 2548));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2548)
            ];
        }
    }
});
var ExploreZone = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7283).then(__webpack_require__.bind(__webpack_require__, 17283));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17283)
            ];
        }
    }
});
var Facilities = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(3400)]).then(__webpack_require__.bind(__webpack_require__, 33400));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33400)
            ];
        }
    }
});
var FlexibleLegal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8269).then(__webpack_require__.bind(__webpack_require__, 28269));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28269)
            ];
        }
    }
});
var FlexibleText = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9720).then(__webpack_require__.bind(__webpack_require__, 59720));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59720)
            ];
        }
    }
});
var Gallery = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8801).then(__webpack_require__.bind(__webpack_require__, 68801));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68801)
            ];
        }
    }
});
var GenericActivities = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(8497)]).then(__webpack_require__.bind(__webpack_require__, 8497));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8497)
            ];
        }
    }
});
var Histories = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(4609)]).then(__webpack_require__.bind(__webpack_require__, 94609));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94609)
            ];
        }
    }
});
var Housing = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(334)]).then(__webpack_require__.bind(__webpack_require__, 40334));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40334)
            ];
        }
    }
});
var MapTemplate = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9936).then(__webpack_require__.bind(__webpack_require__, 89936));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89936)
            ];
        }
    }
});
var NewOpening = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5009).then(__webpack_require__.bind(__webpack_require__, 95009));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95009)
            ];
        }
    }
});
var Newsletter = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1643).then(__webpack_require__.bind(__webpack_require__, 21643));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21643)
            ];
        }
    }
});
var Press = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(9796)]).then(__webpack_require__.bind(__webpack_require__, 49796));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49796)
            ];
        }
    }
});
var PriceDetail = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1591).then(__webpack_require__.bind(__webpack_require__, 41591));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41591)
            ];
        }
    }
});
var PriceSave = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5255).then(__webpack_require__.bind(__webpack_require__, 35255));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35255)
            ];
        }
    }
});
var Recomended = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(5896)]).then(__webpack_require__.bind(__webpack_require__, 85896));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85896)
            ];
        }
    }
});
var SharedSpaces = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(5352)]).then(__webpack_require__.bind(__webpack_require__, 65352));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(65352)
            ];
        }
    }
});
var SpecficActivities = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(2316)]).then(__webpack_require__.bind(__webpack_require__, 2316));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2316)
            ];
        }
    }
});
var Sustainability = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6502).then(__webpack_require__.bind(__webpack_require__, 36502));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(36502)
            ];
        }
    }
});
var WhatToDo = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(5518), __webpack_require__.e(3263)]).then(__webpack_require__.bind(__webpack_require__, 63263));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63263)
            ];
        }
    }
});
var WhatsIncluded = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8544).then(__webpack_require__.bind(__webpack_require__, 88544));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88544)
            ];
        }
    }
});
var WhereWeAre = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7400).then(__webpack_require__.bind(__webpack_require__, 37400));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37400)
            ];
        }
    }
});
var FLEXIBLE_CONTENT_MAPS = {
    Contenidoflexible_Contenido_Hero: Hero,
    Contenidoflexible_Contenido_NoTePierdasNada: Newsletter,
    Contenidoflexible_Contenido_Faqs: Faqs,
    Contenidoflexible_Contenido_LaVidaEnBeCasa: LaVidaEnBeCasa,
    Contenidoflexible_Contenido_Mapa: MapTemplate,
    Contenidoflexible_Contenido_ModuloTarjetas_beneficio: Benefits,
    Contenidoflexible_Contenido_ModuloTarjetas_blog: CardsBlog,
    Contenidoflexible_Contenido_ModuloTarjetas_historia: Histories,
    Contenidoflexible_Contenido_ModuloTarjetas_otros: GeneralCards,
    Contenidoflexible_Contenido_ModuloTarjetas_recomendaciones: Recomended,
    Contenidoflexible_Contenido_ModuloTarjetas_sobreNosotros: AboutUs,
    Contenidoflexible_Contenido_ModuloTarjetas_actividadesGenericas: GenericActivities,
    Contenidoflexible_Contenido_ModuloTarjetas_actividadesEspecificas: SpecficActivities,
    Contenidoflexible_Contenido_ModuloTarjetas_instalaciones: Facilities,
    Contenidoflexible_Contenido_Apartamentos: Apartments,
    Contenidoflexible_Contenido_Alojamientos: Housing,
    Contenidoflexible_Contenido_Cross: CrossTemplate,
    Contenidoflexible_Contenido_QueIncluye: WhatsIncluded,
    Contenidoflexible_Contenido_QueHacer: WhatToDo,
    Contenidoflexible_Contenido_ExploreZone: ExploreZone,
    Contenidoflexible_Contenido_Press: Press,
    Contenidoflexible_Contenido_NewOpening: NewOpening,
    Contenidoflexible_Contenido_Gallery: Gallery,
    Contenidoflexible_Contenido_Sustainability: Sustainability,
    Contenidoflexible_Contenido_EstamosAqui: WhereWeAre,
    Contenidoflexible_Contenido_MasInformacion: ContactForm,
    Contenidoflexible_Contenido_FiltroPosts: Blog,
    Contenidoflexible_Contenido_LegalFlexible: FlexibleLegal,
    Contenidoflexible_Contenido_TextoFlexible: FlexibleText,
    Contenidoflexible_Contenido_Precios_Detail: PriceDetail,
    Contenidoflexible_Contenido_Precios_Save: PriceSave,
    Contenidoflexible_Contenido_AnchorMenu: AnchorMenu,
    Contenidoflexible_Contenido_PopupCorner: PopUpCorner,
    Contenidoflexible_Contenido_EspaciosComunes: SharedSpaces,
    Contenidoflexible_Contenido_BuildingCarrousel: BuildingCarrousel,
    Contenidoflexible_Contenido_Popupopenpage: PopUpOpenPage
};
/**
 * FlexibleContent
 */ // TODO: Fix types
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var FlexibleContent = function(param) {
    var flexibleContent = param.flexibleContent, isLanding = param.isLanding;
    var t = (0,useTranslation/* default */.Z)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            flexibleContent.map(function(flexible, index) {
                if (FLEXIBLE_CONTENT_MAPS.hasOwnProperty(flexible === null || flexible === void 0 ? void 0 : flexible.__typename)) {
                    var Component = FLEXIBLE_CONTENT_MAPS[flexible.__typename];
                    // TODO: Fix types
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    return /*#__PURE__*/ (0,react.createElement)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, flexible), {
                        index: index,
                        key: index
                    }));
                }
                // TODO: Remove this when all sections are included
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: 'Section with name "'.concat(flexible === null || flexible === void 0 ? void 0 : flexible.__typename, '" not included in [...uri.js]')
                }, index);
            }),
            !isLanding && /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsappPopup, {
                label: t("whatsappPopup.label"),
                url: t("whatsappPopup.url"),
                icon: "https://cmseditor.becasaessential.com/wp-content/uploads/2026/04/whatsapp_logo.png"
            })
        ]
    });
};
FlexibleContent.displayName = "FlexibleContent";

;// CONCATENATED MODULE: ./components/templates/flexible-content/index.ts

/* harmony default export */ var flexible_content = (FlexibleContent);


/***/ }),

/***/ 67792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ grid_location; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(46572);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(78962);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 1 modules
var container = __webpack_require__(82112);
// EXTERNAL MODULE: ./components/atoms/caption/index.ts + 1 modules
var caption = __webpack_require__(38959);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
// EXTERNAL MODULE: ./components/molecules/search-box-locations/index.ts + 3 modules
var search_box_locations = __webpack_require__(74371);
// EXTERNAL MODULE: ./components/atoms/grid/index.ts + 2 modules
var grid = __webpack_require__(81246);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(77215);
// EXTERNAL MODULE: ./node_modules/react-paginate/dist/react-paginate.js
var react_paginate = __webpack_require__(87890);
var react_paginate_default = /*#__PURE__*/__webpack_require__.n(react_paginate);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(62123);
// EXTERNAL MODULE: ./public/assets/icons/Derecha.svg
var Derecha = __webpack_require__(19078);
// EXTERNAL MODULE: ./public/assets/icons/Izquierda.svg
var Izquierda = __webpack_require__(59213);
;// CONCATENATED MODULE: ./components/molecules/pagination/Pagination.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      flex flex-row items-center gap-3\n      ",
        "  \n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Pagination = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, onPageChange = param.onPageChange, _pageRangeDisplayed = param.pageRangeDisplayed, pageRangeDisplayed = _pageRangeDisplayed === void 0 ? 2 : _pageRangeDisplayed, pageCount = param.pageCount, _renderOnZeroPageCount = param.renderOnZeroPageCount, renderOnZeroPageCount = _renderOnZeroPageCount === void 0 ? function() {
        return null;
    } : _renderOnZeroPageCount;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((react_paginate_default()), {
        previousLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)(Izquierda["default"], {
            width: 24,
            height: 24,
            className: "fill-state-primary-default [&>ellipse]:!fill-transparent"
        }),
        nextLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)(Derecha["default"], {
            width: 24,
            height: 24,
            className: "fill-state-primary-default [&>ellipse]:!fill-transparent"
        }),
        pageClassName: "flex flex-row gap-3 items-center justify-center [&>a]:px-2 [&>a]:py-1 select-none text-center border-b border-transparent text-body--primary cursor-pointer",
        activeClassName: "!border-state-primary-default !cursor-default pointer-events-none font-bold",
        disabledClassName: "pointer-events-none opacity-40",
        onPageChange: onPageChange,
        pageRangeDisplayed: pageRangeDisplayed,
        pageCount: pageCount,
        renderOnZeroPageCount: renderOnZeroPageCount,
        marginPagesDisplayed: 0,
        breakLabel: null,
        className: (0,es/* oneLine */.f9)(_templateObject(), disabled ? "pointer-events-none opacity-40" : "", className)
    });
};
Pagination.displayName = "Pagination";

;// CONCATENATED MODULE: ./components/molecules/pagination/index.ts

/* harmony default export */ var pagination = (Pagination);

;// CONCATENATED MODULE: ./lib/hooks/usePagination.ts

var DEFAULT_CONFIG = {
    perPage: 12,
    page: 0,
    offset: 0
};
/**
 * Hook to manage pagination
 * @param {T[]} data Data to paginate
 * @param {TypeConfigPagination} config Configuration for pagination
 * @returns {TypePagination} Pagination data
 */ var usePagination = function(data, config) {
    var ref = config || {}, _perPage = ref.perPage, perPage = _perPage === void 0 ? DEFAULT_CONFIG.perPage : _perPage, _page = ref.page, page = _page === void 0 ? DEFAULT_CONFIG.page : _page, _offset = ref.offset, offset = _offset === void 0 ? DEFAULT_CONFIG.offset : _offset;
    // We start with an empty list of items.
    var ref1 = (0,react.useState)([]), currentItems = ref1[0], setCurrentItems = ref1[1];
    var ref2 = (0,react.useState)(page), currentPage = ref2[0], setCurrentPage = ref2[1];
    // Here we use item offsets; we could also use page offsets
    // following the API or data you're working with.
    var ref3 = (0,react.useState)(offset), itemOffset = ref3[0], setItemOffset = ref3[1];
    var itemsPerPage = perPage;
    (0,react.useEffect)(function() {
        // TODO: Permitir hacer el fetch de los datos
        // Fetch items from another resources.
        var endOffset = itemOffset + itemsPerPage;
        setCurrentItems(data.slice(itemOffset, endOffset));
        setCurrentPage(Math.ceil(data.length / itemsPerPage));
    }, [
        itemOffset,
        itemsPerPage,
        data
    ]);
    // Invoke when user click to request another page.
    var handlePageChange = function(event) {
        var newOffset = event.selected * itemsPerPage % data.length;
        setItemOffset(newOffset);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return {
        currentItems: currentItems,
        currentPage: currentPage,
        handlePageChange: handlePageChange
    };
};

// EXTERNAL MODULE: ./lib/utils/utils.tsx
var utils = __webpack_require__(52994);
;// CONCATENATED MODULE: ./components/organisms/cards-pagination/CardsPagination.tsx





var CardsPagination = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, children = param.children;
    var ref = usePagination((0,utils/* toArray */.qo)(children)), currentItems = ref.currentItems, currentPage = ref.currentPage, handlePageChange = ref.handlePageChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-6 md:gap-20 ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.Z, {
                xs: 1,
                md: 2,
                lg: 3,
                outline: false,
                className: "gap-5 md:gap-8",
                children: currentItems.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                        children: item
                    }, index);
                })
            }),
            currentItems.length !== (0,utils/* toArray */.qo)(children).length && /*#__PURE__*/ (0,jsx_runtime.jsx)(pagination, {
                onPageChange: handlePageChange,
                pageCount: currentPage,
                className: "mx-auto"
            })
        ]
    });
};
CardsPagination.displayName = "CardsPagination";

;// CONCATENATED MODULE: ./components/organisms/cards-pagination/index.ts

/* harmony default export */ var cards_pagination = (CardsPagination);

// EXTERNAL MODULE: ./components/organisms/housing-card/index.ts + 1 modules
var housing_card = __webpack_require__(76589);
// EXTERNAL MODULE: ./lib/utils/gtm/helpers.ts
var helpers = __webpack_require__(47675);
;// CONCATENATED MODULE: ./components/templates/grid-location/GridLocation.tsx












/**
 * GridLocation
 */ var GridLocation = function(_param) {
    var ancestor = _param.ancestor, buildings = _param.buildings, description = _param.description, pretitle = _param.pretitle, title = _param.title, searchBox = _param.searchBox, props = (0,_object_without_properties/* default */.Z)(_param, [
        "ancestor",
        "buildings",
        "description",
        "pretitle",
        "title",
        "searchBox"
    ]);
    var ref = (0,react.useState)(searchBox.provinces.defaultValue), selectedProvince = ref[0], setSelectedProvince = ref[1];
    var ref1;
    var ref2 = (0,react.useState)((0,_object_spread/* default */.Z)({
        cities: searchBox.cities.citiesList.find(function(city) {
            return city.includes((ref1 = selectedProvince === null || selectedProvince === void 0 ? void 0 : selectedProvince.id) !== null && ref1 !== void 0 ? ref1 : -1);
        })
    }, searchBox.cities.defaultValue ? {
        defaultValue: searchBox.cities.defaultValue
    } : {
        placeholder: searchBox.cities.placeholder
    })), abailablesCities = ref2[0], setAbailableCities = ref2[1];
    (0,react.useEffect)(function() {
        // Esto se hace para evitar recargar la web cuando entramos a la poblacion directamente
        // Sino al cambiar la provicnia la primera vez recargarria y nos redigiria a la provincia.
        if (searchBox.provinces.defaultValue !== selectedProvince) {
            var ref;
            (0,helpers/* gtmPush */.De)({
                event: "booking_search",
                provincia: (ref = selectedProvince === null || selectedProvince === void 0 ? void 0 : selectedProvince.label) !== null && ref !== void 0 ? ref : "",
                edificio: "",
                tipo: "",
                fecha: ""
            });
            var ref1;
            router_default().push((ref1 = selectedProvince === null || selectedProvince === void 0 ? void 0 : selectedProvince.href) !== null && ref1 !== void 0 ? ref1 : "#");
        }
        var ref2;
        setAbailableCities((0,_object_spread/* default */.Z)({
            cities: searchBox.cities.citiesList.find(function(city) {
                return city.includes((ref2 = selectedProvince === null || selectedProvince === void 0 ? void 0 : selectedProvince.id) !== null && ref2 !== void 0 ? ref2 : -1);
            })
        }, searchBox.cities.defaultValue ? {
            defaultValue: searchBox.cities.defaultValue
        } : {
            placeholder: searchBox.cities.placeholder
        }));
    }, [
        selectedProvince
    ]);
    var onCitiesChanges = function(city) {
        var ref;
        (0,helpers/* gtmPush */.De)({
            event: "booking_search",
            provincia: (ref = selectedProvince === null || selectedProvince === void 0 ? void 0 : selectedProvince.label) !== null && ref !== void 0 ? ref : "",
            edificio: city.label
        });
        router_default().push(city.href);
    };
    var onProvincesChanges = function(value) {
        setSelectedProvince(searchBox.provinces.values.find(function(province) {
            return province.id === value.id;
        }));
    };
    (0,react.useEffect)(function() {
        var ref;
        setAbailableCities((0,_object_spread/* default */.Z)({
            cities: searchBox.cities.citiesList.find(function(city) {
                return city.includes((ref = selectedProvince === null || selectedProvince === void 0 ? void 0 : selectedProvince.id) !== null && ref !== void 0 ? ref : -1);
            })
        }, searchBox.cities.defaultValue ? {
            defaultValue: searchBox.cities.defaultValue
        } : {
            placeholder: searchBox.cities.placeholder
        }));
    }, [
        searchBox
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: "section",
        className: "!pb-6 !pt-20 md:!pb-20 md:!pt-40",
        backgroundColorTop: "surface-01"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-9 flex flex-col md:mb-16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(caption/* default */.Z, {
                        className: "mb-4",
                        children: pretitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-heading-mobile--h1 max-w-xl md:text-heading--h1",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-8 grid max-w-xl grid-cols-1 gap-4 md:my-10 md:grid-cols-2 md:gap-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(search_box_locations/* default */.Z, {
                            onProvincesChange: onProvincesChanges,
                            onCitiesChange: onCitiesChanges,
                            //eslint-disable-next-line
                            //@ts-ignore
                            cities: abailablesCities,
                            provinces: searchBox.provinces
                        })
                    }),
                    ancestor && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: ancestor.href,
                        prefetch: false,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                            variant: "primary",
                            underline: true,
                            className: "mb-8",
                            children: ancestor.label
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-body--primary font-thin md:text-heading--h5",
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_pagination, {
                children: buildings.map(function(building, index) {
                    return /*#__PURE__*/ (0,react.createElement)(housing_card/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, building), {
                        province: selectedProvince,
                        characteristicsOrientation: "column",
                        className: "h-full",
                        key: index
                    }));
                })
            })
        ]
    }));
};
GridLocation.displayName = "GridLocation";

;// CONCATENATED MODULE: ./components/templates/grid-location/index.ts

/* harmony default export */ var grid_location = (GridLocation);


/***/ }),

/***/ 47675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "De": function() { return /* binding */ gtmPush; },
/* harmony export */   "JQ": function() { return /* binding */ sha256; }
/* harmony export */ });
/* unused harmony export debugGtm */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36045);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74772);


var debugGtm = function(debugMsg, data) {
    var isProd = "production" === "production";
    // eslint-disable-next-line no-console
    if (!isProd) console.log("".concat(debugMsg, ": "), data);
};
var gtmPush = function(data) {
    var // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ref;
    (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.push(data);
    debugGtm("GTM PUSH", data);
};
function sha256(message) {
    return _sha256.apply(this, arguments);
}
function _sha256() {
    _sha256 = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(message) {
        var msgUint8, hashBuffer, hashArray, hashHex;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
                    return [
                        4,
                        crypto.subtle.digest("SHA-256", msgUint8)
                    ];
                case 1:
                    hashBuffer = _state.sent();
                    hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
                    hashHex = hashArray.map(function(b) {
                        return b.toString(16).padStart(2, "0");
                    }).join(""); // convert bytes to hex string
                    return [
                        2,
                        hashHex
                    ];
            }
        });
    });
    return _sha256.apply(this, arguments);
}


/***/ })

}]);